import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // On non-home pages, navbar is always "scrolled" style (solid bg)
  const navActive = scrolled || !isHome;

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${navActive ? 'bg-paper/80 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center">
        <Link to="/" className={`flex items-center gap-3 text-2xl font-bold tracking-tighter ${navActive ? 'text-ink' : 'text-white'}`}>
          <img 
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1781865268786-image.png" 
            alt="Curve Logo" 
            className="w-8 h-8 rounded-[10px] object-cover shadow-sm"
          />
          Curve
        </Link>
        
        <div className="hidden md:flex items-center gap-8">
          {isHome ? (
            <>
              <a href="#features" className={`text-sm font-medium hover:opacity-70 transition-opacity ${navActive ? 'text-ink/80' : 'text-white/80'}`}>Features</a>
              <a href="#how-it-works" className={`text-sm font-medium hover:opacity-70 transition-opacity ${navActive ? 'text-ink/80' : 'text-white/80'}`}>How it works</a>
              <a href="#privacy" className={`text-sm font-medium hover:opacity-70 transition-opacity ${navActive ? 'text-ink/80' : 'text-white/80'}`}>Privacy</a>
            </>
          ) : (
            <Link to="/" className={`text-sm font-medium hover:opacity-70 transition-opacity ${navActive ? 'text-ink/80' : 'text-white/80'}`}>Home</Link>
          )}
          <Link to="/contact" className={`text-sm font-medium hover:opacity-70 transition-opacity ${navActive ? 'text-ink/80' : 'text-white/80'}`}>Contact</Link>
        </div>
        
        <Link 
          to="/contact" 
          className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all shadow-sm ${navActive ? 'bg-ink text-white hover:bg-gray-800' : 'bg-white text-ink hover:bg-gray-100'}`}
        >
          Get the app
        </Link>
      </div>
    </nav>
  );
};